(function () {
  function initChips(root) {
    if (!root || root.dataset.chipsReady === '1') return;
    root.dataset.chipsReady = '1';

    var toggles = root.querySelectorAll('[data-family-toggle]');
    var panels = root.querySelectorAll('[data-family-panel]');

    function setOpen(familyId, open) {
      toggles.forEach(function (btn) {
        var isMatch = btn.getAttribute('data-family-id') === familyId;
        var shouldOpen = open && isMatch;
        btn.classList.toggle('is-open', shouldOpen);
        btn.classList.toggle('is-active', shouldOpen);
        btn.setAttribute('aria-expanded', shouldOpen ? 'true' : 'false');
      });
      panels.forEach(function (panel) {
        var isMatch = panel.getAttribute('data-family-id') === familyId;
        var shouldOpen = open && isMatch;
        panel.classList.toggle('is-open', shouldOpen);
        if (shouldOpen) {
          panel.removeAttribute('hidden');
        } else {
          panel.setAttribute('hidden', '');
        }
      });
    }

    toggles.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var id = btn.getAttribute('data-family-id');
        var alreadyOpen = btn.classList.contains('is-open');
        if (alreadyOpen) {
          setOpen(id, false);
        } else {
          setOpen(id, true);
        }
      });
    });
  }

  function initAll() {
    document.querySelectorAll('[data-stacees-chips]').forEach(initChips);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target && event.target.querySelector
      ? event.target.querySelector('[data-stacees-chips]')
      : null;
    if (root) {
      root.dataset.chipsReady = '';
      initChips(root);
    } else if (event.target && event.target.matches && event.target.matches('[data-stacees-chips]')) {
      event.target.dataset.chipsReady = '';
      initChips(event.target);
    }
  });
})();
